<template>
  <div class="links-container font-rubik flex flex-col gap-1">
    <a v-if="getSolution('Container Rentals')" class="resources-dropdown-a flex items-center justify-between" :href="getLinkPath('rentals')">
      <span class="underline">Container Rentals</span>
      <img class="h-6" src="@/images/service-area-cards/arrow-outward.svg" alt="Arrow">
    </a>
    <a v-if="getSolution('Container Modifications')" class="resources-dropdown-a flex items-center justify-between" :href="getLinkPath('modifications')">
      <span class="underline">Container Modifications</span>
      <img class="h-6" src="@/images/service-area-cards/arrow-outward.svg" alt="Arrow">
    </a>
    <a v-if="getSolution('Portable Offices')" class="resources-dropdown-a flex items-center justify-between" :href="getLinkPath('portable')">
      <span class="underline">Portable Offices</span>
      <img class="h-6" src="@/images/service-area-cards/arrow-outward.svg" alt="Arrow">
    </a>
  </div>
</template>

<script>
export default {
  props: {
    organization: {
      required: true,
      type: Object
    },
    solutions: {
      required: true,
      type: Array
    }
  },
  computed: {
    currentUrl() {
      return window.location.pathname
    }
  },
  methods: {
    getBasePath() {
      if (this.currentUrl.includes('partners')) {
        return `/partners/${this.organization.slug}`
      } else if (this.currentUrl.includes('solutions')) {
        return '/solutions'
      }
      return ''
    },
    getLinkPath(linkType) {
      const basePath = this.getBasePath()
      switch (linkType) {
      case 'about':
        return basePath
      case 'sales':
        return `${basePath}/container-sales`
      case 'rentals':
        return `${basePath}/container-rentals`
      case 'modifications':
        return `${basePath}/container-modifications`
      case 'refrigerated':
        return `${basePath}/refrigerated-containers`
      case 'portable':
        return `${basePath}/portable-offices`
      default:
        return ''
      }
    },
    getSolution(solution) {
      return this.solutions.find((s) => {
        return s.title.includes(solution)
      })
    }
  }
}
</script>

<style scoped>
.links-container {
  width: 288px;
}
.resources-dropdown-a {
  border: 1px solid #E2E1DE;
  background-color: white;
  border-radius: 8px;
  height: 42px;
  width: 100%;
  padding: 12px;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #000000;
  transition: background-color 0.3s ease, transform 0.3s ease;
}
.resources-dropdown-a:hover {
  --tw-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.resources-dropdown-a img {
  padding: 2px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border-radius: 50%;
  border: 1px solid black;
}
.resources-dropdown-a:hover img {
  padding: 2px;
  background-color: #ffffff;
  transform: rotate(45deg);
  box-shadow: 0 0 0 1px #ffffff;
}

/* mobile */
@media(max-width: 1024px) {
  .links-container {
    display: none;
    /* margin-left: 20px;
    margin-right: 20px;
    width: auto;
    margin-bottom: 30px; */
  }
}
</style>
